import request from "@/api";

// export function listOrder(data) {
//     return request({
//         url: '/api/order/getOrderList',
//         method: 'get',
//         params: data
//     })
// }

// export function getOrderInfo(data) {
//     return request({
//         url: '/api/order/getOrderInfo',
//         method: 'get',
//         params: data
//     })
// }

export function saveOrderAddress(data) {
    return request({
        url: '/api/order/saveOrderAddress',
        method: 'post',
        data: data
    })
}

// export function deleteOrder(data) {
//     return request({
//         url: '/api/order/deleteOrder',
//         method: 'post',
//         data: data
//     })
// }
